import { writable } from 'svelte/store';
import { db } from './firebase';

function createPages() {
    const {subscribe, set, update} = writable({});

    return {
        subscribe,
        update,
        set,
        load: () => {
            if (typeof db !== 'undefined') {
                db.collection('pages').get().then(querySnapshot => {
                    const newValue = {};

                    querySnapshot.forEach(doc => {
                        newValue[doc.id] = {
                            id: doc.id,
                            page: doc.data(),
                        };
                    });

                    set({});
                    setTimeout(()=>{
                        set(newValue);
                    }, 0);
                });
            } else {
                return set({});
            }
        },
    };
}

function createPage() {
    const {subscribe, set, update} = writable({});

    return {
        subscribe,
        update,
        set,
        load: id => {
            if (typeof db !== 'undefined') {
                db.collection('pages').doc(id).get().then(doc => {
                    set({});
                    if (doc.exists) {
                        setTimeout(()=>{
                            if (doc.exists) {
                                set(doc.data());
                            }
                        }, 0);
                    }
                });
            } else {
                set({});
            }
        },
    };
}

function createSurveys() {
    const {subscribe, set, update} = writable({});

    return {
        subscribe,
        update,
        set,
        load: () => {
            if (typeof db !== 'undefined') {
                db.collection('surveys').get().then(querySnapshot => {
                    const newValue = {};

                    querySnapshot.forEach(doc => {
                        newValue[doc.id] = {
                            id: doc.id,
                            survey: doc.data(),
                        };
                    });

                    set({});
                    setTimeout(()=>{
                        set(newValue);
                    }, 0);
                });
            } else {
                return set({});
            }
        },
    };
}

function createSurvey() {
    const {subscribe, set, update} = writable({});

    return {
        subscribe,
        update,
        set,
        load: id => {
            if (typeof db !== 'undefined') {
                db.collection('surveys').doc(id).get().then(doc => {
                    set({});
                    setTimeout(()=>{
                        if (doc.exists) {
                            set(doc.data());
                        }
                    }, 0);
                });
            } else {
                set({});
            }
        },
    };
}

export const pages = createPages();
export const page = createPage();
export const surveys = createSurveys();
export const survey = createSurvey();
